// src/js/components/enrollment-modal.js

document.addEventListener("DOMContentLoaded", () => {
  const modal          = document.getElementById("enrollment-modal");
  if (!modal) return;

  const modalContent   = modal.querySelector(".js-enroll-modal-content");
  const formPanel      = document.getElementById("enroll-modal-form-panel");
  const successPanel   = document.getElementById("enroll-modal-success-panel");
  const errorPanel     = document.getElementById("enroll-modal-error-panel");
  const errorMsg       = document.getElementById("enroll-error-msg");
  const errorText      = document.getElementById("enroll-send-error-text");
  const form           = document.getElementById("enrollment-form");
  const submitBtn      = document.getElementById("enroll-submit-btn");
  const btnText        = document.getElementById("enroll-btn-text");
  const btnIcon        = document.getElementById("enroll-btn-icon");
  const btnSpinner     = document.getElementById("enroll-btn-spinner");
  const retryBtn       = document.getElementById("enroll-retry-btn");

  const courseNameInput = document.getElementById("enroll-course-name");
  const courseCodeInput = document.getElementById("enroll-course-code");

  // --- Abrir / Cerrar modal ---

  const openModal = (courseTitle, courseCode) => {
    // Reset estado
    [formPanel, errorMsg].forEach(el => el && el.classList.remove("hidden"));
    [successPanel, errorPanel].forEach(el => el && el.classList.add("hidden"));
    if (form) form.reset();
    resetConditionalFields();

    // Set course info
    if (courseNameInput) {
      const divClean = document.createElement("div");
      divClean.innerHTML = courseTitle || "Curso de Formación";
      courseNameInput.value = divClean.textContent || divClean.innerText || "";
    }
    if (courseCodeInput) {
      courseCodeInput.value = (courseCode || "").toUpperCase();
    }

    modal.classList.remove("opacity-0", "pointer-events-none");
    modalContent.classList.remove("scale-95");
    modalContent.classList.add("scale-100");
    document.body.style.overflow = "hidden";
    modal.scrollTop = 0;
  };

  const closeModal = () => {
    modal.classList.add("opacity-0", "pointer-events-none");
    modalContent.classList.remove("scale-100");
    modalContent.classList.add("scale-95");
    document.body.style.overflow = "";
  };

  // --- Triggers ---

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest(".js-enrollment-modal-trigger");
    if (trigger) {
      e.preventDefault();
      const card = trigger.closest("[data-course-card]");
      const title = card ? card.dataset.courseTitle : "";
      const code = card ? card.dataset.courseCode : "";
      openModal(title, code);
    }
  });

  modal.querySelectorAll(".js-enroll-modal-close").forEach(btn => {
    btn.addEventListener("click", closeModal);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !modal.classList.contains("pointer-events-none")) {
      closeModal();
    }
  });

  // --- Lógica de campos condicionales ---

  const expWrapper = document.getElementById("wrapper-experiencia-desc");
  const expRadios = form.querySelectorAll('input[name="experiencia_previa"]');

  function resetConditionalFields() {
    if (expWrapper) expWrapper.classList.add("hidden");
  }

  expRadios.forEach(radio => {
    radio.addEventListener("change", () => {
      if (radio.value === "Sí") {
        expWrapper.classList.remove("hidden");
      } else {
        expWrapper.classList.add("hidden");
      }
    });
  });

  // Manejo de "Otros"
  const otherTriggers = form.querySelectorAll(".js-enroll-other-trigger");
  otherTriggers.forEach(trigger => {
    const targetId = trigger.dataset.target;
    const targetInput = document.getElementById(targetId);
    
    trigger.addEventListener("change", () => {
      if (trigger.checked) {
        setTimeout(() => targetInput.focus(), 50);
      }
    });
    
    const groupName = trigger.name;
    const groupRadios = form.querySelectorAll(`input[name="${groupName}"]`);
    groupRadios.forEach(radio => {
      if (radio !== trigger) {
        radio.addEventListener("change", () => {
          if (targetInput) {
            targetInput.value = "";
          }
        });
      }
    });
  });

  // --- Reintentar ---

  if (retryBtn) {
    retryBtn.addEventListener("click", () => {
      errorPanel.classList.add("hidden");
      formPanel.classList.remove("hidden");
      setLoading(false);
    });
  }

  // --- Helpers ---

  function setLoading(loading) {
    if (!submitBtn) return;
    submitBtn.disabled = loading;
    if (btnText)    btnText.textContent = loading ? "Enviando..." : "Solicitar inscripción";
    if (btnIcon)    btnIcon.classList.toggle("hidden", loading);
    if (btnSpinner) btnSpinner.classList.toggle("hidden", !loading);
  }

  function validate() {
    let valid = true;
    const requiredTexts = ["nombre", "dni", "fecha_nacimiento", "direccion", "telefono", "email", "motivacion"];
    requiredTexts.forEach(name => {
      const el = form.querySelector(`[name="${name}"]`);
      if (el && !el.value.trim()) valid = false;
    });

    const emailEl = form.querySelector('[name="email"]');
    if (emailEl && emailEl.value && !emailEl.value.includes("@")) valid = false;

    const radioGroups = ["nivel_estudios", "situacion_actual", "experiencia_previa", "canal_conocimiento"];
    radioGroups.forEach(name => {
      const checked = [...form.querySelectorAll(`input[name="${name}"]`)].some(r => r.checked);
      if (!checked) valid = false;
    });

    const priv = form.querySelector('[name="acepta_privacidad"]');
    const conf = form.querySelector('[name="confirma_datos"]');
    if (priv && !priv.checked) valid = false;
    if (conf && !conf.checked) valid = false;

    return valid;
  }

  function collectData() {
    const fd = new FormData(form);
    const data = {};
    for (const [key, value] of fd.entries()) {
      data[key] = value;
    }

    // Sustituir "Otros" por valor del input si aplica
    const otherMappings = [
      { radioId: "nivel-otros-check", textId: "nivel_estudios_otros", key: "nivel_estudios" },
      { radioId: "situacion-otros-check", textId: "situacion_actual_otros", key: "situacion_actual" },
      { radioId: "canal-otros-check", textId: "conociste_otros", key: "canal_conocimiento" }
    ];

    otherMappings.forEach(m => {
      const radio = document.getElementById(m.radioId);
      const text = document.getElementById(m.textId);
      if (radio && radio.checked && text && text.value.trim()) {
        data[m.key] = `Otros: ${text.value.trim()}`;
      }
    });

    return data;
  }

  // --- Envío ---

  if (form) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      if (errorMsg) errorMsg.classList.add("hidden");

      if (!validate()) {
        if (errorMsg) {
          errorMsg.classList.remove("hidden");
          errorMsg.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }

      setLoading(true);
      const data = collectData();

      // reCAPTCHA v3
      if (typeof grecaptcha !== 'undefined') {
        const siteKey = process.env.PARCEL_PUBLIC_RECAPTCHA_SITE_KEY || '6Ld_placeholder_site_key_fam';
        data.recaptchaToken = await grecaptcha.execute(siteKey, { action: 'enrollment' });
      }

      try {
        const response = await fetch("/.netlify/functions/send-cursos", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data)
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}`);
        }

        setLoading(false);
        formPanel.classList.add("hidden");
        successPanel.classList.remove("hidden");
        modal.scrollTop = 0;

      } catch (err) {
        console.error("Error al enviar inscripción:", err);
        setLoading(false);
        if (errorText) errorText.textContent = "Ha ocurrido un problema al enviar tu inscripción. Por favor, inténtalo de nuevo.";
        formPanel.classList.add("hidden");
        errorPanel.classList.remove("hidden");
        modal.scrollTop = 0;
      }
    });
  }
});
